export const selectSubscriptionProductFamily = state => state.data.subscriptionProductFamily.selectedProduct;
